import { Constants } from 'constants/Constants';
import oAxiosInstance from 'redux/interceptors/Interceptors';
import { Buffer } from 'buffer';

const URL_ADMIN = `${Constants.API_URL}auth/`;
/**
 * Servicio que valida la existencia del usuario con esa credencial de usuario.
 * 
 * @param {string} sEmail Credencial de usuario para checkear
 * 
 * @author Leandro Curbelo
 */
export const CheckUsername = (sEmail) => {
    return oAxiosInstance.post(`${URL_ADMIN}`, { data: { email: sEmail } }).then(oResult => oResult.data)
}
/**
 * Servicio de login, envia un email y contraseña para que el API la valide.
 * 
 * @param {string} sEmail Nombre de usuario o email
 * @param {string} sPassword Password del usuario
 * 
 * @author Leandro Curbelo
 */
export const Login = (sEmail, sPassword) => {
   sPassword = Buffer.from(sPassword).toString('base64');
   return oAxiosInstance.post(`${URL_ADMIN}login`, { data: { email: sEmail, password: sPassword } }).then(oResult => oResult.data)
   //return oAxiosInstance.post(`${URL_ADMIN}login`, { data: { email: sEmail, password: btoa(sPassword) } }).then(oResult => oResult.data)  
  }

/**
 * Servicio de logout, envia la peticion al API para eliminar la sesion actual
 * 
 * @author Leandro Curbelo
 */
export const Logout = () => {
    return oAxiosInstance.get(`${URL_ADMIN}logout`).then(oResult => oResult.data)
}
/**
 * Servicio que checkea si el token aun se encuentra vigente o expiro
 * 
 * @author Leandro Curbelo
 */
export const CheckToken = () => {
    return oAxiosInstance.get(`${URL_ADMIN}check/credentials`).then(oResult => oResult.data)
}